import { Component, ElementRef, ChangeDetectorRef, OnInit } from "@angular/core"
import { FilmsService } from "./films.service"

import TemplateString from "./app.component.html"

@Component({
  selector: "filmsindex",
  template: TemplateString,
})
export class AppComponent implements OnInit {
  archive: boolean
  activeFestival: string
  year: number
  films: object
  query: string = ""
  formats: Array<string> = ["Feature", "Short"]
  viewing: string = "In-Theater"
  p: number = 1
  teenScreen: boolean = false
  currentFestival: string = "FESTIVAL/PROGRAM"
  currentYear: string = "YEAR FEATURED"
  currentGenre: string = "GENRE"
  currentCountry: string = "COUNTRY"
  currentLanguage: string = "LANGUAGE"
  currentInterest: string = "TOPIC/INTEREST"
  currentTheme: string = "THEME"
  currentFormat: string = "FORMAT"
  currentGrade: string = "GRADE"

  constructor(
    private elementRef: ElementRef,
    private filmsService: FilmsService,
    private cdref: ChangeDetectorRef,
  ) {
    if (this.elementRef.nativeElement.getAttribute("festival") !== null) {
      this.currentFestival =
        this.elementRef.nativeElement.getAttribute("festival")

      if (this.currentFestival === "fp-fall-festival") {
        this.currentFestival = "fall-festival"
      }
    } else {
      this.archive = true
    }
    if (
      this.elementRef.nativeElement.getAttribute("active_festival") !== null
    ) {
      this.activeFestival = this.elementRef.nativeElement
        .getAttribute("active_festival")
        .toLowerCase()
        .replace("_", "-")
    }
    if (this.elementRef.nativeElement.getAttribute("year") !== null) {
      this.year = this.elementRef.nativeElement.getAttribute("year")
    }
    if (this.elementRef.nativeElement.getAttribute("viewing") !== null) {
      this.viewing = this.elementRef.nativeElement.getAttribute("viewing")
    }
    if (this.elementRef.nativeElement.getAttribute("teenscreen") !== null) {
      this.teenScreen = true
    }
  }

  // functions
  receiveQuery($event) {
    this.query = $event
  }

  receiveFilter($event) {
    this[$event.type] = $event.content
    this.cdref.detectChanges()
  }

  scrollToTop() {
    window.scrollTo(0, 0)
  }

  getFilms(teenScreen): void {
    this.filmsService
      .getFilms(teenScreen)
      .subscribe((films) => (this.films = films))
  }

  ngOnInit(): void {
    this.getFilms(this.teenScreen)
  }
}
